<template>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="width: 100%;padding:0 20px;">
        <!-- <el-tab-pane label="定价管理" name="first">
            <el-table ref="multipleTable" :data="priceList" tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="constantTypeName" label="名称" align="center" show-overflow-tooltip />
                <el-table-column prop="maxCount" label="最大可选数量" align="center" show-overflow-tooltip/>
                <el-table-column prop="updateTime" label="更新时间" align="center" show-overflow-tooltip/>
            </el-table>
        </el-tab-pane> -->
        <el-tab-pane label="定价管理" name="second">
            <el-form :model="discountForm" :inline="true" ref="ruleForm" :rules="formRules">
                <el-form-item label="套餐类型">
                    <el-select v-model="discountForm.packageType" placeholder="" style="width:100px" >
                        <el-option v-for="item in packageTypes" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐名称" prop="packageName">
                    <el-input v-model="discountForm.packageName" placeholder="请输入套餐名称" maxlength="10"/>
                </el-form-item>
                <el-form-item label="售价" prop="realPrice">
                    <el-input-number v-model="discountForm.realPrice" :precision="2" controls-position="right"/>元
                </el-form-item>
                <el-form-item label="划线价" prop="originalPrice">
                    <el-input-number v-model="discountForm.originalPrice" :precision="2" controls-position="right"/>元
                </el-form-item>
                <el-form-item label="有效期" prop="count">
                    <el-input-number v-model="discountForm.count" :controls="false" :precision="0" style="width:80px;"/>
                    <el-select v-model="discountForm.packageDurationType" placeholder="" style="width:60px; margin-left:5px">
                        <el-option :label="'月'" :value="1"/>
                        <el-option :label="'天'" :value="2"/>
                    </el-select>
                </el-form-item>
                <el-button type="primary" plain icon="el-icon-circle-plus-outline"  @click="addDiscount('ruleForm')">添加</el-button>
            </el-form>
            
            
            <el-table ref="multipleTable" :data="discountList"  border="" tooltip-effect="dark" style="width: 100%; margin-top:20px"
                @cell-dblclick="dbclickAction">
                <el-table-column label="排序" prop="showIndex" align="center">
                    <template #header>
                        <span>排序</span>
                        <el-tooltip class="item" effect="dark" content="正序排序，双击进行编辑" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template #default="scope">
                        <el-input-number v-model="scope.row.showIndex" v-if="scope.row.isEdit" 
                        controls-position="right" :min="0" :controls="false" style="width:100%"
                        @blur="blurAction(scope.row)" ref="tableInput"
                        @keydown.enter.native="tableInputEnterAction(scope.row)"/>
                        <span v-else>{{ scope.row.showIndex }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="packageType" label="套餐类型" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">{{makePackageTypeStr(scope.row.packageType)}}</template>
                </el-table-column>
                <el-table-column prop="packageName" label="套餐名称" align="center" show-overflow-tooltip/>
                <el-table-column prop="realPrice" label="售价（元）" align="center" :formatter="realPriceFormat" show-overflow-tooltip/>
                <el-table-column prop="originalPrice" label="划线价（元）" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>
                            {{scope.row.originalPrice.value}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="monthCount" label="有效期" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.packageDurationType == 1 ? scope.row.monthCount+'个月' : scope.row.dayCount+'天'}}
                    </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="更新时间" align="center" show-overflow-tooltip/>
                <el-table-column width="150" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button :type="scope.row.packageStatus == 1 ? 'primary' : 'info'" plain @click="editDiscount(scope.row)">
                            {{scope.row.packageStatus == 1 ? '已启用' : '已禁用'}}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    export default {
        name: "backPriceManage",
        data() {
            return {
                activeName: 'second',
                priceList: [],
                discountForm:{
                    packageType: 0,//套餐类型(0普通套餐1体验套餐)
                    packageName: '',//套餐名称
                    packageDurationType:1,//套餐时长类型(1月数2天数)
                    count: 0,
                    monthCount: null, //订阅时长，月数(时长类型为天数时该字段为null)
                    dayCount: null, //订阅时长，天数(时长类型为月数时该字段为null)
                    originalPrice: null, //原价
                    realPrice: null, //现价
                },
                formRules: {
                    packageName:[
                        { required: true, message: '请输入套餐名称', trigger: 'blur' },
                        { min: 0, max: 10, message: '长度在 0 到 10 个字符', trigger: 'blur' }
                    ],
                    realPrice:[
                        { validator: (rule, value, callback)=>{
                            if (value < 1 ){
                                callback(new Error('售价必须大于等于1'));
                            }
                            callback();
                        }, trigger: 'blur'}
                    ],
                    originalPrice:[
                        { validator: (rule, value, callback)=>{
                            if (value < 1 ){
                                callback(new Error('划线价必须大于等于1'));
                            }
                            callback();
                        }, trigger: 'blur'}
                    ],
                    count:[
                        { validator: (rule, value, callback)=>{
                            if (value <= 0 ){
                                callback(new Error('有效期必须大于0'));
                            }else if(value >= 30 && this.discountForm.packageDurationType == 2){
                                callback(new Error('天数大于或等于30，请选择月份进行添加'));
                            }

                            callback();
                        }, trigger: 'blur'}
                    ]
                },
                discountList:[],
                packageTypes:[
                    {value: 0, label: '普通套餐'},
                    {value: 1, label: '体验套餐'}
                ]
            };
        },
        created() {
        },
        mounted() {
            // this.requestTradePriceList();
            this.requestDiscountList();
        },
        methods: {
            realPriceFormat({realPrice}) {
                return (realPrice/100).toFixed(2)
            },
            handleClick(tab) {//切换tab
                // console.log(tab.index);
                if(tab.index==0){
                    // this.requestTradePriceList();
                    this.requestDiscountList();
                }
            },
            cellEdit(row, column) {
                // console.log(row, column, cell, event)
                if (column.property == 'generalTerm') {
                    this.maskShow = true;
                }
                if (column.property != 'id' && column.property != 'generalTerm') {
                    row[column.property].edit = true;
                    setTimeout(() => {
                        console.log(this.$refs, column.property);
                        this.$refs[column.property][0].focus()
                    }, 20)
                }
            },
            savePrice(id, price) {//保存价格
                let loading = this.$loading(this.utils.defaultLoadingOptions);
                console.log(id, price);
                this.$request.modifyPrice({
                    id,
                    price: price * 100
                }).then(res => {
                    console.log(res);
                    loading.close();
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: '保存成功！'
                        });
                    } else {
                        this.requestError(res.status, res.message)
                    }
                }, err => {
                    console.log(err)
                    loading.close();
                    this.requestFail(err)
                })
            },
            deleteDiscount(id){//删除折扣
                console.log(id)
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let loading = this.$loading(this.utils.defaultLoadingOptions);
                    this.$request.deleteDiscount([id]).then(res => {
                        loading.close();
                        if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功！'
                            });
                            this.requestDiscountList();
                        } else {
                            this.$message({
                                type: 'info',
                                message: '删除失败！'
                            });
                            this.requestError(res.status, res.message)
                        }
                    }, err => {
                        console.log(err)
                        loading.close();
                        this.requestFail(err);
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            addDiscount(formName){//添加折扣
                this.$refs[formName].validate(valid => {
                    if(valid){
                        if(this.discountForm.originalPrice < this.discountForm.realPrice){
                            this.$message({ message: '划线价不能小于售价', type: 'error' });
                            return false;
                        }
                        var message = '有效期'+this.discountForm.count + (this.discountForm.packageDurationType == 1 ? '个月' : '天') +'，';
                        message = message + `划线价${this.discountForm.originalPrice}元，售价${this.discountForm.realPrice}元,是否添加?`
                        this.$confirm(message, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        }).then(() => {
                            if(this.discountForm.packageDurationType == 1){
                                this.discountForm.monthCount = this.discountForm.count;
                                this.discountForm.dayCount = null;
                            }else{
                                this.discountForm.dayCount = this.discountForm.count;
                                this.discountForm.monthCount = null;
                            }
                            this.discountForm.originalPrice = this.discountForm.originalPrice * 100;
                            this.discountForm.realPrice = this.discountForm.realPrice * 100;
                            let loading = this.$loading(this.utils.defaultLoadingOptions);
                            this.$request.addDiscount(this.discountForm).then( res => {
                                loading.close();
                                this.discountForm.packageType = 0;
                                this.discountForm.packageName = '';
                                this.discountForm.packageDurationType = 1;
                                this.discountForm.count = 0;
                                this.discountForm.monthCount = null;
                                this.discountForm.dayCount = null;
                                this.discountForm.originalPrice = null;
                                this.discountForm.realPrice = null;
                                if(res.status==200&&res.data==1){
                                    this.$message({ message: '添加成功！', type: 'success' });
                                    this.requestDiscountList();
                                }else {
                                    this.requestError(res.status,res.message)
                                }
                            }, err => {
                                loading.close();
                                this.requestFail(err);
                            });
                        });
                    }else{
                        return false;
                    }
                });
            },
            
            /**修改折扣状态 */
            editDiscount(val){
                this.$request.editDiscount({id:val.id, packageStatus:val.packageStatus==1?0:1}).then( res => {
                    console.debug(res);
                    if(res.status == 200){
                        this.$message({ message: res.message, type: 'success' });
                        this.requestDiscountList();
                    }else{
                        this.requestError(res.status, res.message)
                    }
                }, err => {
                    this.requestFail(err);
                });
            },
            dbclickAction(row, column, cell, event){
                console.debug(row,column.property , cell, event);
                if(column.property == 'showIndex') {
                    row.isEdit = true;
                    let then = this;
                    console.debug(column.rowSpan);
                    window.setTimeout(() => {
                        var refInput = then.$refs.tableInput;
                        if(refInput){
                            refInput.focus();
                        }
                    },300);
                }
            },
            
            blurAction(val){
                if(val.isEdit){
                    this.tableInputEnterAction(val);
                }
            },
            
            
            tableInputEnterAction(val){
                val.isEdit = false;
                window.setTimeout(() => {
                    this.$request.editDiscount({id:val.id, showIndex:val.showIndex}).then(res => {
                        if(res.status == 200){
                            this.$message({ message: res.message, type: 'success' });
                            this.requestDiscountList();
                        }else{
                            this.requestError(res.status, res.message)
                        }
                    }, err => {
                        this.requestFail(err);
                    });
                },100);
                
            },
            requestTradePriceList(){
                let loading = this.$loading(this.utils.defaultLoadingOptions);

                this.$request.tradePriceList().then(res => {
                    console.log(res);
                    loading.close();
                    if (res.status == 200) {
                        res.data.forEach(item => {
                            item.unitPrice = {
                                value: (item.unitPrice / 100).toFixed(2),
                                edit: true
                            }
                        });
                        console.log(res.data);
                        this.priceList = res.data;
                    } else {
                        this.requestError(res.status, res.message)
                    }

                }, err => {
                    console.log(err);
                    loading.close();
                    this.requestFail(err);
                })
            },
            requestDiscountList(){
                let loading = this.$loading(this.utils.defaultLoadingOptions);
                this.$request.discountList().then(res=>{
                    console.log(res);
                    loading.close();
                    if(res.status==200){
                        res.data.forEach(item => {
                            item.originalPrice = {
                                value: (item.originalPrice / 100).toFixed(2),
                                edit: true
                            }
                            item.isEdit = false;
                        });
                        this.discountList = res.data;
                    }else {
                        this.requestError(res.status,res.message)
                    }
                },err=>{
                    console.log(err);
                    loading.close();
                    this.requestFail(err);
                })
            },

            makePackageTypeStr(val){
                var str = '';
                this.packageTypes.forEach(element => {
                    if(val == element.value){
                        str = element.label;
                    }
                });
                return str;
            }
        }
    }
</script>

<style scoped lang="less">
    .input-very-small{
        width: 170px;
    }
    .el-table_2_column_11{
        border-bottom: none !important;
    }
</style>